module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAJNJREFUKBVjYAACZ2fnLE9PT1EQGxdgAin69+/f1J8/f+7Hp5iJjY1tNSMj49X///9r41PMCLIKZBJIEUgxSBM7O7vj9u3bXyM7A6yQGMVwhYQUoyjEpxhDIS7FTCAJYgCGibhCAEUhLkUgG+EK8SmCKySkCKyQGEUghUysrKw/gPRHXFEHUgQHfn5+vCCT4QJYGACVoJH2cySrnAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart6-icon/arrow_left_m.png
// module id = 1296
// module chunks = 7